module.exports = __webpack_public_path__ + "img/lamp.df9590b1.png";